import * as yup from 'yup';

import { IdentityType, RepresentativeRole } from '@blockpulse3/graphql/hooks';
import { formatCountry, formatNationality } from '@blockpulse3/helpers';
import {
  requiredDateField,
  requiredEmailField,
  requiredNumberField,
  requiredSelectField,
  requiredStringField,
} from '@blockpulse3/web-client/forms';

import { IRepresentativeForm } from './types';

export const representativeFormDefaults: IRepresentativeForm = {
  /* ** Common ** */
  id: null,
  type: IdentityType.COMPANY,
  role: RepresentativeRole.PRESIDENT,
  address: {
    line: '',
    city: '',
    postalCode: '',
    country: { label: formatCountry('FRA'), value: 'FRA' },
  },
  /* ** Company ** */
  name: '',
  registrationEntity: '',
  registrationNumber: '',
  nominalValue: 0,
  birthdate: '',
  birthplace: '',
  corporateForm: '',
  creationDate: '',
  shareCapital: 0,
  country: { label: formatCountry('FRA'), value: 'FRA' },
  nationality: { label: formatNationality('FRA'), value: 'FRA' },
  /* ** Individual ** */
  firstName: '',
  lastName: '',
  email: '',
  position: '',
};

export const legalRepresentativeFormSchema = yup.object({
  name: requiredStringField,
  corporateForm: requiredStringField,
  shareCapital: requiredNumberField,
  registrationEntity: requiredStringField,
  registrationNumber: requiredStringField,
  address: yup.object({
    line: requiredStringField,
    city: requiredStringField,
    postalCode: requiredStringField,
    country: requiredSelectField,
  }),
  firstName: requiredStringField,
  lastName: requiredStringField,
  position: requiredStringField,
  email: requiredEmailField,
}) as yup.ObjectSchema<IRepresentativeForm>;

export const naturalRepresentativeFormSchema = yup.object({
  firstName: requiredStringField,
  lastName: requiredStringField,
  email: requiredEmailField,
  nationality: requiredSelectField,
  birthdate: requiredDateField,
  birthplace: requiredStringField,
  address: yup.object({
    line: requiredStringField,
    city: requiredStringField,
    postalCode: requiredStringField,
    country: requiredSelectField,
  }),
}) as yup.ObjectSchema<IRepresentativeForm>;
